const QRVALUE_ACTION_TYPES = {
  SELECTED_QRVALUE: 'SELECTED_QRVALUE',
  ADD: {
    IN_PROGRESS: 'ADD_QRVAlUE_IN_PROGRESS',
    SUCCESS: 'ADD_QRVAlUE_SUCCESS',
    ERROR: 'ADD_QRVAlUE_ERROR',
  },
  GET_BY_ID: {
    IN_PROGRESS: 'GET_QRVAlUE_BY_ID_IN_PROGRESS',
    SUCCESS: 'GET_QRVAlUE_BY_ID_SUCCESS',
    ERROR: 'GET_QRVAlUE_BY_ID_ERROR',
  },
  POST: {
    IN_PROGRESS: 'GET_QRVAlUE_IN_PROGRESS',
    SUCCESS: 'GET_QRVAlUE_SUCCESS',
    ERROR: 'GET_QRVAlUE_ERROR',
  },
  EDIT: {
    IN_PROGRESS: 'EDIT_QRVAlUE_IN_PROGRESS',
    SUCCESS: 'EDIT_QRVAlUE_SUCCESS',
    ERROR: 'EDIT_QRVAlUE_ERROR',
  },
  DELETE: {
    IN_PROGRESS: 'DELETE_QRVAlUE_IN_PROGRESS',
    SUCCESS: 'DELETE_QRVAlUE_SUCCESS',
    ERROR: 'DELETE_QRVAlUE_ERROR',
  },
};

export default QRVALUE_ACTION_TYPES;
